import { IsomorphicHelpers } from '../helpers/IsomorphicHelpers';

export const readCookie = (name: string) => {
    let result;

    if (IsomorphicHelpers.isServerSide) {
        const cookies = IsomorphicHelpers.request?.cookies[name];
        if (cookies) {
            result = new RegExp(`(?:^|; )([^;]*)`).exec(cookies);
        }
    } else if (typeof document !== 'undefined') {
        result = new RegExp(`(?:^|; )${encodeURIComponent(name)}=([^;]*)`).exec(document.cookie);
    }
    return result ? result[1] : null;
};

export const writeCookie = (name: string, value: string, days: number = 365): void => {
    const date = new Date();
    const maxAge = days * 24 * 60 * 60 * 1000;
    date.setTime(date.getTime() + maxAge);

    if (typeof location !== 'undefined') {
        const domainParts = location.hostname.split('.').slice(1);
        const expires = `; expires=${date.toUTCString()}`;
        const domainString = `;domain=.${domainParts.join('.')}`;
        if (location.hostname === 'localhost') {
            // condition for testing cookie on local only
            document.cookie = `${name}=${value}${expires}; path=/`;
        } else {
            document.cookie = `${name}=${value}${expires}; path=/${domainString}`;
        }
    }
};
